import o, { useState as P, useCallback as G } from "react";
import { useTheme as J, Text as K, Box as p } from "@chakra-ui/react";
import { motion as Q } from "framer-motion";
import "react-icons/md";
import "./button.js";
import { IconButton as V } from "./icon-button.js";
import "react-icons/fa";
import "@loadable/component";
import "./masthead-button.js";
import "@chakra-ui/system";
import { FiCheck as X } from "react-icons/fi";
import { HiPlus as Y } from "react-icons/hi";
import { RiLoader4Line as Z } from "react-icons/ri";
import "react-icons/io5";
import "./close-button.js";
var $ = /* @__PURE__ */ ((t) => (t.NOT_APPLICABLE = "NOT_APPLICABLE", t.ADD_TO_LIST = "ADD_TO_LIST", t.WITHIN_LIST = "WITHIN_LIST", t))($ || {});
const ee = ({ isLoading: t, shoppingListStatus: n }) => {
  const a = {
    rotate: 360,
    transition: { duration: 1, repeat: 1 / 0, ease: "linear" }
  };
  return t ? /* @__PURE__ */ o.createElement(Q.div, { animate: a }, /* @__PURE__ */ o.createElement(Z, null)) : n === "ADD_TO_LIST" ? /* @__PURE__ */ o.createElement(p, null, /* @__PURE__ */ o.createElement(Y, null)) : /* @__PURE__ */ o.createElement(p, null, /* @__PURE__ */ o.createElement(X, null));
}, Ie = ({
  addToListCta: { text: t, url: n },
  removeFromListCta: { text: a, url: D },
  shoppingListStatus: r,
  onAddToList: s,
  onRemoveFromList: c,
  ariaLabels: m
}) => {
  const {
    atl: {
      borderRadius: E,
      onDefault: g,
      iconSize: u,
      buttonWidth: h,
      buttonHeight: x,
      padding: S,
      gap: k,
      backgroundDefault: f,
      borderDefault: T,
      elevation: B,
      backgroundPressed: O,
      onPressed: b,
      borderPressed: W,
      onAdded: v,
      backgroundAdded: I,
      borderAdded: A,
      borderWidthAdded: w,
      onAddedPressed: L,
      borderAddedPressed: H,
      backgroundAddedPressed: N
    },
    atlText: M
  } = J();
  if (r === "NOT_APPLICABLE")
    return null;
  const [y, _] = P(!1), [i, d] = P(!1), e = r === "ADD_TO_LIST", R = e ? t : a, z = e ? n : D, F = e ? m.addToShoppingList : m.withinShoppingList, U = () => /* @__PURE__ */ o.createElement(
    ee,
    {
      isLoading: y,
      shoppingListStatus: r
    }
  ), j = G(async () => {
    d(!i), _(!0), e ? await s(n) : r === "WITHIN_LIST" && await c(z), _(!1);
  }, [i, r, s, c]), l = e ? g : v, C = {
    bg: e ? O : N,
    color: e ? b : L,
    fill: e ? b : L,
    borderColor: e ? W : H
  }, q = {
    bg: e ? f : I,
    color: l,
    borderColor: e ? T : A
  };
  return /* @__PURE__ */ o.createElement(
    V,
    {
      role: "button",
      "aria-label": F,
      color: l,
      icon: U,
      fill: l,
      iconWidth: u,
      iconHeight: u,
      w: h,
      h: x,
      p: S,
      gap: k,
      bg: e ? f : I,
      borderColor: e ? T : A,
      borderWidth: !e && w,
      borderRadius: E,
      boxShadow: B,
      _focus: q,
      _hover: C,
      _active: C,
      "aria-pressed": i,
      onClick: j,
      onMouseLeave: () => {
        d(!1);
      },
      onMouseDown: () => d(!0),
      onMouseUp: () => d(!1)
    },
    /* @__PURE__ */ o.createElement(K, { ...M }, R)
  );
};
export {
  Ie as AddToListButton,
  $ as ShoppingListStatusTypes
};
